import * as Yup from 'yup';

export default Yup.object().shape({
    requestor: Yup.number()
        .required('Field cannot be empty'),
    requestee: Yup.array().min(1, "at least one requestee")
        .required('Field cannot be empty'),

});
